import { request } from 'd3components/src/utils/request';

const isMock = String(import.meta.env.VITE_USE_MOCK) === 'true';
// 存储每个账号发送的 mock 验证码
const mockCodeStore: Record<string, string> = {};

// 发送验证码（在 mock 时返回 mockCode ）
export async function sendCode(account: string): Promise<{ code: number; msg: string; mockCode?: string }> {
  if (isMock) {
    // 模拟电话验证
    const isValid = /^1\d{10}$/.test(String(account).trim());
    return new Promise((resolve) => {
      setTimeout(() => {
        if (!isValid) {
          resolve({ code: 1, msg: '手机号无效' });
        } else {
          // 生成随机验证码
          const mockCode = String(Math.floor(100000 + Math.random() * 900000));
          // 记录当前账号的 mock 验证码
          mockCodeStore[String(account).trim()] = mockCode;
          resolve({ code: 0, msg: 'ok', mockCode });
        }
      }, 300);
    });
  }
  // 之前后真实接口的话就使用这部分
  const res = await request.post({
    url: '/auth/sendCode',
    data: { account },
  });
  return res;
}

// 重置密码
export async function resetPassword(params: {
  account: string;
  password: string;
  code: string;
}): Promise<{ code: number; msg: string }>
{
  if (isMock) {
    const { account, password, code } = params;
    const normalizedAccount = String(account).trim();
    const validPhone = /^1\d{10}$/.test(normalizedAccount);
    const validPwd = typeof password === 'string' && password.length >= 2 && password.length <= 20;
    const validCode = typeof code === 'string' && /^\d{6}$/.test(code);
    return new Promise((resolve) => {
      setTimeout(() => {
        if (!validPhone) return resolve({ code: 1, msg: '手机号无效' });
        if (!validPwd) return resolve({ code: 1, msg: '密码不符合规则' });
        if (!validCode) return resolve({ code: 1, msg: '验证码错误' });
        const lastCode = mockCodeStore[normalizedAccount];
        if (!lastCode || code !== lastCode) return resolve({ code: 1, msg: '验证码错误' });
        // 验证通过后清理存储
        delete mockCodeStore[normalizedAccount];
        resolve({ code: 0, msg: 'ok' });
      }, 300);
    });
  }
  // 有真实接口的时候替换，现在线占位
  const res = await request.post({
    url: '/auth/resetPassword',
    data: params,
  });
  return res;
}
